/**
 * LoginLinkScreen — le bouton « Me connecter » de l'e-mail de code (`login-link`), sur le design system.
 *
 * Un fil : l'échange du lien et ses gestes (`useLoginLinkState`), le view-model, puis la page.
 * Portage de `src/auth/LoginLinkScreen.js` ; la route est posée dans toutes les piles.
 */
import { useSelector } from "react-redux"

import { LoginLinkPage } from "../../../../../../design-system"
import { AuthStatusBar } from "../AuthStatusBar"
import { loginLinkViewModel } from "../../../../view-models/auth/LoginLink/loginLinkViewModel"
import { useLoginLinkState } from "./useLoginLinkState"

type LoginLinkScreenProps = {
    route?: { params?: { token?: string } }
}

export function LoginLinkScreen({ route }: LoginLinkScreenProps) {
    const link = useLoginLinkState(route?.params?.token)
    const vm = useSelector((state: unknown) => loginLinkViewModel(state, link.failed, link.pendingSwitch))

    return (
        <>
            <LoginLinkPage
                status={vm.status}
                currentUserName={vm.currentUserName}
                linkUserName={vm.linkUserName}
                onRequestNewCode={link.onRequestNewCode}
                onContinueAsLinkUser={link.onContinueAsLinkUser}
                onStayAsCurrentUser={link.onStayAsCurrentUser}
            />
            <AuthStatusBar />
        </>
    )
}

export default LoginLinkScreen
